import styled from 'styled-components';

export const UnderstandConsignmentBand = styled.div`
  background-color: #e9ecf3;
`;

export const UnderstandConsignmentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  padding-block: 30px;

  @media only screen and (min-width: 576px) {
    gap: 40px;
    padding-block: 40px;
  }
`;

export const UnderstandConsignmentHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  img {
    width: 184px;
    height: 52px;
    margin-bottom: 10px;
  }
`;

export const ConsignTitle = styled.h4`
  font-weight: 700;
  font-size: 24px;
  color: #1e242f;
  text-align: center;
  margin: 0;
`;

export const ConsignmentPlanImage = styled.img`
  width: 100%;
  height: auto;
`;

export const BenefitGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;

  @media only screen and (min-width: 576px) {
    gap: 12px;
  }
`;

export const BenefitItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;

  height: 100%;
  padding: 12px 20px;
  background-color: #fff;
  border-radius: 4px;

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    gap: 6px;
    padding: 10px 6px;
    justify-content: center;
    text-align: center;
  }

  @media only screen and (max-width: 375px) {
    grid-column: span 2;
  }
`;

export const BenefitIcon = styled.img`
  height: 64px;
  width: 64px;

  @media only screen and (max-width: 575px) {
    height: 60px;
    width: 60px;
  }
`;

export const BenefitLabel = styled.p`
  flex: 1;
  font-weight: 700;
  font-size: 13px;
  color: #374255;
  margin: 0;

  @media only screen and (max-width: 575px) {
    font-size: 10px;
    text-align: center;
  }
`;
